export const partnerHierarchyTranslation = {
  controls: {
    search: 'partner_hierarchy-control-search',
    found: 'partner_hierarchy-control-found',
    export: 'partner_hierarchy-control-export',
  },
  table: {
    columns: {
      hierarchy: 'partner_hierarchy-table-columns-hierarchy',
      partnerId: 'partner_hierarchy-table-columns-partner_id',
      partnerName: 'partner_hierarchy-table-columns-partner_name',
    },
    rowActions: {
      edit: 'partner_hierarchy-table-row_actions-edit',
    },
  },
}
